import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import styled from "styled-components";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, color: "black" }}
      onClick={onClick}
    >
      <ArrowForwardIosRoundedIcon />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, color: "black" }}
      onClick={onClick}
    >
      <ArrowBackIosRoundedIcon />
    </div>
  );
}

const SlideStyled = styled.div`
  padding: 0 50px;
  box-sizing: border-box;
  & img {
    width: 45px;
    height: 45px;
    border-radius: 50px;
    margin: auto;
  }
  & p {
    text-align: center;
  }
  & p:first-of-type {
    font-weight: 200;
    padding-bottom: 10px;
    margin-top: 10px;
  }
`;

const Slide = ({ student, img, children }) => {
  return (
    <SlideStyled>
      <img src={img} />
      <p>{student}</p>
      <p>
        <i>{children}</i>
      </p>
    </SlideStyled>
  );
};

const SimpleSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div style={{ width: "80%", margin: "80px auto 20px" }}>
      <Slider {...settings}>
        <Slide student="Albano Villar" img="img/albano.jpeg">
          "He tenido el honor de ser su alumno y viendo la implicación que ha
          tenido por enseñarnos y la paciencia, estoy totalmente convencido que
          eres una trabajadora de 10 y una compañera de 100. Gracias por todo."
        </Slide>
        <Slide student="Nerea Tovar" img="img/nerea.jpeg">
          "¡Muchas gracias por todo lo que nos has transmitido!"
        </Slide>
        <Slide student="Fernando Vazquez" img="img/fernando.jpeg">
          "Contigo parece fácil. ¡Un abrazo!"
        </Slide>
        <Slide student="Jasmina Güell" img="img/jasmina.jpeg">
          "El placer es nuestro, muchas gracias. ¡Ya aplicando los nuevos
          conocimientos!"
        </Slide>
        <Slide student="Joseba Iturregui" img="img/joseba.jpeg">
          "Cuesta encontrarse con gente tan comprometida, implicada y con don de
          gente como tú has demostrado. Definitivamente tú eres un asset muy
          importante en este posgrado y en nuestro aprendizaje. ¡Espero nos
          veamos pronto mi amigo!"
        </Slide>
        <Slide student="Daniel Aquilino" img="img/daniel.jpeg">
          "Profesores increíbles y 100% comprometidos. Un trato al alumno
          fantástico, procurando siempre que haya interacción en la clase así
          como también valorando e impulsando la creatividad y desarrollo
          personal. Humildes, simpáticos y muy profesionales."
        </Slide>
        <Slide student="Antonio Molis" img="img/antonio.jpeg">
          "Una persona encantadora y una gran profesional. Una desarrolladora
          apasionada con un profundo conocimiento del frontend, respaldado por
          su amplia experiencia. Es la compañera que todos desean tener en su
          equipo. Personalmente, he aprendido mucho de ella. "
        </Slide>
        <Slide student="Santiago Palomo" img="img/santiago.jpeg">
          "Hemos aprendido mucho gracias a tu esfuerzo y tu cercanía. En mis
          desarrollos siempre estarán presentes tus buenas prácticas."
        </Slide>
      </Slider>
    </div>
  );
};

export default SimpleSlider;
